import { useState, useEffect, useRef } from 'react';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { useDebouncedCallback } from 'use-debounce';
import { AutoComplete } from '@progress/kendo-react-dropdowns';
import ScanBarCode from './ScanBarCode';
import BarCodeScanSuccess from './BarCodeScanSuccess';
import {
  searchStoreCities,
  searchStoreLocations,
} from '../../store/actions/masterData/masterData.action';
import { setToasterMessage } from '../../store/actions/commonAction/common.action';
import backArrow from '../../assets/img/backArrow.png';
import { getLocationTypesForBarCode } from '../../utils/utils';

const BarCodeScreen = ({ closeBarModal }) => {
  const [locationTypeSelect, setLocationTypeSelect] = React.useState('');
  const [searchedStoreLocations, setSearchedStoreLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState('');
  const [city, setCity] = useState('');
  const [, setUpdateCityCode] = useState('');
  const [geoCity, setGeoCity] = useState('');
  const [isScannerVisible, setIsScannerVisible] = useState(false);
  const [isScanSuccess, setIsScanSuccess] = useState(false);
  const [isSubmitvisible, setIsSubmitvisible] = useState(false);
  const storeCities = useSelector(
    (state) => state.masterDataReducer.storeCities
  );
  const storeLocations = useSelector(
    (state) => state.masterDataReducer.storeLocations
  );
  const locationIdRef = useRef();
  const dispatch = useDispatch();
  let optionsData = [];

  optionsData = searchedStoreLocations.map(({ code, name, id }) => {
    return {
      value: code,
      label: name,
      id: id,
    };
  });

  const [requiredFields] = useState({
    location: false,
    locationType: false,
    city: false,
  });

  useEffect(() => {
    setSearchedStoreLocations(storeLocations);
  }, [storeLocations]);

  const changeLocationType = (e) => {
    setLocationTypeSelect(e.target.value);
    const params = new URLSearchParams();
    params.append('locationType', e.target.value);
    params.append('size', 2000);
    params.append('active', true);
    params.append('sort', 'e.name');
    params.append('e.name', 'asc');
    params.append('cityCode', '');
    setSelectedLocationId('');
    setCity('');
    if (locationIdRef?.current?.select?.props?.value) {
      locationIdRef.current.select.props.value.label =
        'Search or select location from dropdown';
    }
    dispatch(searchStoreLocations('?' + params.toString()));
  };

  const selectedStoreLocation = (e) => {
    if (e.value) {
      setSelectedLocationId(e.value);
    }
  };

  const updateCityDebounce = useDebouncedCallback((value) => {
    dispatch(
      searchStoreCities({
        name: encodeURIComponent(value + '%'),
        active: true,
      })
    );
  }, 500);

  const updateCity = (event) => {
    const { value } = event.target;
    setUpdateCityCode('');
    setGeoCity('');
    setCity(value);
    updateCityDebounce(value);
    if (event.target.value === '') {
      const params = new URLSearchParams();
      params.append('locationType', locationTypeSelect);
      params.append('size', 2000);
      params.append('active', true);
      params.append('sort', 'e.name');
      params.append('e.name', 'asc');
      params.append('cityCode', '');
      setSelectedLocationId('');
      if (locationIdRef?.current?.select?.props?.value) {
        locationIdRef.current.select.props.value.label =
          'Search or select location from dropdown';
      }
      dispatch(searchStoreLocations('?' + params.toString()));
    }
  };

  useEffect(() => {
    if (storeCities.length > 0) {
      storeCities.map((value) => {
        if ([geoCity].includes(value.name)) {
          setUpdateCityCode(value.code);
          setCity(geoCity);
        }
      });
    }
  }, [storeCities]);

  useEffect(() => {
    if (storeCities.length > 0) {
      storeCities.map((value) => {
        if ([city].includes(value.name)) {
          setUpdateCityCode(value.code);
          setCity(city);
          const params = new URLSearchParams();
          params.append('locationType', locationTypeSelect);
          params.append('size', 2000);
          params.append('active', true);
          params.append('sort', 'e.name');
          params.append('e.name', 'asc');
          params.append('cityCode', value.code);
          setSelectedLocationId('');
          if (locationIdRef?.current?.select?.props?.value) {
            locationIdRef.current.select.props.value.label =
              'Search or select location from dropdown';
          }
          dispatch(searchStoreLocations('?' + params.toString()));
        }
      });
    }
  }, [city]);

  const getLocationData = (e) => {
    e.preventDefault();
    setIsScannerVisible(true);
    setIsSubmitvisible(true);
  };

  const barCodeScanSuccess = (isSuccess) => {
    setIsScanSuccess(isSuccess);
    setIsScannerVisible(false);
  };

  const scanNewAppointmentId = () => {
    setIsScanSuccess(false);
    setIsScannerVisible(true);
    setIsScannerVisible(true);
  };

  const barCodeClose = () => {
    setIsSubmitvisible(false);
    setIsScanSuccess(false);
    setIsScannerVisible(false);
    closeToaster();
    setLocationTypeSelect('');
    setSelectedLocationId('');
  };

  const closeToaster = () => {
    dispatch(
      setToasterMessage({
        showToaster: false,
        toasterMessage: '',
        toasterType: '',
        statusCode: '',
      })
    );
  };

  const locationTypeList = getLocationTypesForBarCode();

  return (
    <div className="middleContent" id="barCodeImg">
      {!isSubmitvisible && (
        <form className="location-form">
          <div className="row">
            <div className="col-lg-12">
              <h4 className="pageTitle">
                <span className="pageTitle backArrow" onClick={closeBarModal}>
                  <img src={backArrow} alt="Back" />
                </span>{' '}
                Choose Location
              </h4>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  Location Type <em>*</em>
                </label>
                <select
                  onChange={changeLocationType}
                  value={locationTypeSelect}
                  className="form-control"
                >
                  <option value="">Select</option>
                  {Object.keys(locationTypeList).map((selecteOption) => {
                    return (
                      <option key={selecteOption} value={selecteOption}>
                        {locationTypeList[selecteOption]}
                      </option>
                    );
                  })}
                  {requiredFields.locationType && (
                    <p className="errorMsg">Location Type is required.</p>
                  )}
                </select>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>City</label>
                <AutoComplete
                  data={storeCities}
                  textField="name"
                  className="form-control"
                  value={city}
                  onChange={updateCity}
                  id="city"
                  placeholder="City"
                />
                {requiredFields.city ? (
                  <p className="errorMsg">City is required.</p>
                ) : requiredFields.cityCode ? (
                  <p className="errorMsg">Please enter correct city.</p>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className="col-lg-4">
              {locationTypeSelect ? (
                <div className="form-group">
                  <label>
                    Location <em>*</em>
                  </label>
                  <Select
                    ref={locationIdRef}
                    placeholder="Search location from dropdown"
                    options={optionsData}
                    onChange={(data) => {
                      selectedStoreLocation(data);
                    }}
                  />
                </div>
              ) : (
                ''
              )}
              {requiredFields.location && (
                <p className="errorMsg">Location is required.</p>
              )}
            </div>
            <div className="col-lg-12 text-right">
              <label>&nbsp;</label>
              <button
                className="goButton"
                disabled={!selectedLocationId}
                onClick={getLocationData}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      )}
      {isScannerVisible && (
        <ScanBarCode
          barCodeScanSuccess={barCodeScanSuccess}
          selectedLocationId={selectedLocationId}
          barCodeClose={barCodeClose}
        />
      )}
      {isScanSuccess && (
        <BarCodeScanSuccess
          scanNewAppointmentId={scanNewAppointmentId}
          closeBarModal={closeBarModal}
        />
      )}
    </div>
  );
};

export default BarCodeScreen;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
